import { useContext } from 'react';
import { BreakpointTrackerContext } from './BreakpointTracker';
import { extendWithBreakpointValues } from './breakpoint.utils';
export const useBreakpoint = props => {
  const breakpoint = useContext(BreakpointTrackerContext);
  const breakpointProps = props && extendWithBreakpointValues(props, breakpoint);
  return {
    breakpointProps,
    applyBreakpoint: componentProps => extendWithBreakpointValues(componentProps, breakpoint),
    breakpoint
  };
};